/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 切换包裹 的 **请求配置**
 *
 * @分类 快手分播设备新增包裹号配置
 * @请求头 `POST /erp/Machine/unbindPackage`
 */
const postUnbindPackageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Machine/unbindPackage",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUnbindPackage",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 切换包裹 的 **请求函数**
 *
 * @分类 快手分播设备新增包裹号配置
 * @请求头 `POST /erp/Machine/unbindPackage`
 */
export const postUnbindPackage = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postUnbindPackageRequestConfig, requestData), ...args);
};
postUnbindPackage.requestConfig = postUnbindPackageRequestConfig;
/**
 * 接口 开始分播 的 **请求配置**
 *
 * @分类 快手分播设备新增包裹号配置
 * @请求头 `POST /erp/Machine/setMachine`
 */
const postSetMachineRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Machine/setMachine",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetMachine",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 开始分播 的 **请求函数**
 *
 * @分类 快手分播设备新增包裹号配置
 * @请求头 `POST /erp/Machine/setMachine`
 */
export const postSetMachine = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSetMachineRequestConfig, requestData), ...args);
};
postSetMachine.requestConfig = postSetMachineRequestConfig;
/**
 * 接口 快手分播监控页面-获取设备分播方案 的 **请求配置**
 *
 * @分类 快手分播设备新增包裹号配置
 * @请求头 `GET /erp/Machine/getMachineCutCase`
 */
const getGetMachineCutCaseRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Machine/getMachineCutCase",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ["machine_id", "machine_cut_type"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetMachineCutCase",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 快手分播监控页面-获取设备分播方案 的 **请求函数**
 *
 * @分类 快手分播设备新增包裹号配置
 * @请求头 `GET /erp/Machine/getMachineCutCase`
 */
export const getGetMachineCutCase = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetMachineCutCaseRequestConfig, requestData),
    ...args
  );
};
getGetMachineCutCase.requestConfig = getGetMachineCutCaseRequestConfig;
/**
 * 接口 设备分播方案详情 的 **请求配置**
 *
 * @分类 快手分播设备新增包裹号配置
 * @请求头 `GET /erp/Machine/getMachineCutCaseDetail`
 */
const getGetMachineCutCaseDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Machine/getMachineCutCaseDetail",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ["machine_id", "machine_cut_type"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetMachineCutCaseDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设备分播方案详情 的 **请求函数**
 *
 * @分类 快手分播设备新增包裹号配置
 * @请求头 `GET /erp/Machine/getMachineCutCaseDetail`
 */
export const getGetMachineCutCaseDetail = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getGetMachineCutCaseDetailRequestConfig, requestData),
    ...args
  );
};
getGetMachineCutCaseDetail.requestConfig =
  getGetMachineCutCaseDetailRequestConfig;
/**
 * 接口 保存设备分播方案 的 **请求配置**
 *
 * @分类 快手分播设备新增包裹号配置
 * @请求头 `POST /erp/Machine/saveMachineCutCase`
 */
const postSaveMachineCutCaseRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Machine/saveMachineCutCase",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveMachineCutCase",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存设备分播方案 的 **请求函数**
 *
 * @分类 快手分播设备新增包裹号配置
 * @请求头 `POST /erp/Machine/saveMachineCutCase`
 */
export const postSaveMachineCutCase = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSaveMachineCutCaseRequestConfig, requestData),
    ...args
  );
};
postSaveMachineCutCase.requestConfig = postSaveMachineCutCaseRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 获取分播数据 的 **请求配置**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/getCutData`
 */
const postGetCutDataRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Machine/getCutData",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetCutData",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取分播数据 的 **请求函数**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/getCutData`
 */
export const postGetCutData = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetCutDataRequestConfig, requestData), ...args);
};
postGetCutData.requestConfig = postGetCutDataRequestConfig;
/**
 * 接口 导入生成分播方案 的 **请求配置**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/importMachineCutCase`
 */
const postImportMachineCutCaseRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Machine/importMachineCutCase",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportMachineCutCase",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入生成分播方案 的 **请求函数**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/importMachineCutCase`
 */
export const postImportMachineCutCase = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportMachineCutCaseRequestConfig, requestData),
    ...args
  );
};
postImportMachineCutCase.requestConfig = postImportMachineCutCaseRequestConfig;
/**
 * 接口 获取分播方案 的 **请求配置**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/getMachineCutCaseToType6`
 */
const postGetMachineCutCaseToType6RequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Machine/getMachineCutCaseToType6",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetMachineCutCaseToType6",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取分播方案 的 **请求函数**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/getMachineCutCaseToType6`
 */
export const postGetMachineCutCaseToType6 = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetMachineCutCaseToType6RequestConfig, requestData),
    ...args
  );
};
postGetMachineCutCaseToType6.requestConfig =
  postGetMachineCutCaseToType6RequestConfig;
/**
 * 接口 获取格口打标ID 的 **请求配置**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/getGridDbid`
 */
const postGetGridDbidRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Machine/getGridDbid",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetGridDbid",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取格口打标ID 的 **请求函数**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/getGridDbid`
 */
export const postGetGridDbid = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetGridDbidRequestConfig, requestData), ...args);
};
postGetGridDbid.requestConfig = postGetGridDbidRequestConfig;
/**
 * 接口 更新方案名称 的 **请求配置**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/saveCaseName`
 */
const postSaveCaseNameRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Machine/saveCaseName",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveCaseName",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 更新方案名称 的 **请求函数**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/saveCaseName`
 */
export const postSaveCaseName = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSaveCaseNameRequestConfig, requestData), ...args);
};
postSaveCaseName.requestConfig = postSaveCaseNameRequestConfig;
/**
 * 接口 更换容器 的 **请求配置**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/updateBoxOnGrid`
 */
const postUpdateBoxOnGridRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Machine/updateBoxOnGrid",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateBoxOnGrid",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 更换容器 的 **请求函数**
 *
 * @分类 #4897
 * @请求头 `POST /erp/Machine/updateBoxOnGrid`
 */
export const postUpdateBoxOnGrid = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postUpdateBoxOnGridRequestConfig, requestData),
    ...args
  );
};
postUpdateBoxOnGrid.requestConfig = postUpdateBoxOnGridRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 配置分播方案限制商品数量上限的默认值 的 **请求配置**
 *
 * @分类 5884
 * @请求头 `POST /erp/Machine/setCommodityQuantityCap`
 */
const postSetCommodityQuantityCapRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Machine/setCommodityQuantityCap",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetCommodityQuantityCap",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 配置分播方案限制商品数量上限的默认值 的 **请求函数**
 *
 * @分类 5884
 * @请求头 `POST /erp/Machine/setCommodityQuantityCap`
 */
export const postSetCommodityQuantityCap = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetCommodityQuantityCapRequestConfig, requestData),
    ...args
  );
};
postSetCommodityQuantityCap.requestConfig =
  postSetCommodityQuantityCapRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/machine.js